"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vertexTaxGroup = exports.endUse = exports.featureDescription = exports.technologies = exports.removableFootbed = exports.midSoleMaterial = exports.largerSizes = exports.smallerSizes = exports.newCommodityCode = exports.commodityCode = exports.upperMaterialGroup = exports.removableInsole = exports.constructionMaking = exports.spinUrl = exports.newVideoUrl = exports.videoUrl = exports.productPurpose = exports.productCollection = exports.sockMaterial = exports.trims = exports.fastening = exports.soleMaterial = exports.liningMaterial = exports.upperMaterial = exports.bootLegHeight = exports.bootLegCircumference = exports.newHeelHeight = exports.heelHeight = exports.legWidth = exports.newWeight = exports.weight = exports.newHeight = exports.height = exports.newWidth = exports.width = exports.newLength = exports.length = exports.countryOfOrigin = exports.seasonIntroduced = exports.seasonYear = exports.season = exports.mediumColor = exports.shortColor = exports.gender = exports.subBrand = exports.brand = exports.productSubType = exports.productType = exports.styleName = exports.styleCode = void 0;
exports.productShortDescription = exports.productTitle = exports.productLaunchDate = exports.isClearance = exports.isFullPriceProduct = exports.productFollow = exports.productIndex = exports.toDate = exports.fromDate = exports.lastOfferedAtDate = exports.shippingAndReturnsImage = exports.shippingAndReturnsText = exports.backgroundColor = exports.foregroundColor = exports.emailText = exports.storefrontText = exports.finalSale = exports.upsellsCheckoutShoesAndShoeCare = exports.upsellsCheckoutToddlerGauges = exports.upsellsCheckoutJuniorGauges = exports.crossSellsPDPWomensShoesAndHandbags = exports.crossSellsPDPMiniMeWomensAndGirls = exports.crossSellsPDPMiniMeMensAndBoys = exports.subTechnologies = exports.productBadges = exports.productSlug = exports.rangeGroupDescription = exports.merchandiseCategory = exports.productEndDate = exports.productAvailabilityDate = exports.newBootShaftCircumference = exports.bootShaftCircumference = exports.newBootShaftHeight = exports.bootShaftHeight = exports.newWeightUnit = exports.weightUnit = exports.newLengthUnit = exports.lengthUnit = exports.newHeightUnit = exports.heightUnit = exports.newWidthUnit = exports.widthUnit = exports.newBootShaftCircumferenceUnit = exports.bootShaftCircumferenceUnit = exports.newBootShaftHeightUnit = exports.bootShaftHeightUnit = exports.newHeelHeightUnit = exports.heelHeightUnit = void 0;
const i18n_1 = require("../common/i18n");
exports.styleCode = {
    name: 'styleCode',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Style Code'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: true,
};
exports.styleName = {
    name: 'styleName',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Style Name'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: true,
};
exports.productType = {
    name: 'productType',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Product Type'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: true,
};
exports.productSubType = {
    name: 'productSubType',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Product SubType'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: true,
};
exports.brand = {
    name: 'brand',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Brand'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: true,
};
exports.subBrand = {
    name: 'subBrand',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Sub-brand'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: true,
};
exports.gender = {
    name: 'gender',
    type: {
        name: 'set',
        elementType: {
            name: 'ltext',
        },
    },
    label: (0, i18n_1.localizedString)('Gender'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: true,
};
exports.shortColor = {
    name: 'shortColor',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Short Color'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: true,
};
exports.mediumColor = {
    name: 'mediumColor',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Medium Color'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.season = {
    name: 'season',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Season'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.seasonYear = {
    name: 'seasonYear',
    type: {
        name: 'number',
    },
    label: (0, i18n_1.localizedString)('Season Year'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.seasonIntroduced = {
    name: 'seasonIntroduced',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Season Introduced'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.countryOfOrigin = {
    name: 'countryOfOrigin',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Country of Origin'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.length = {
    name: 'length',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Length'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.newLength = {
    name: 'length',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Length'),
    attributeConstraint: 'None',
    isRequired: false,
    isSearchable: false,
};
exports.width = {
    name: 'width',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Width'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.newWidth = {
    name: 'width',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Width'),
    attributeConstraint: 'None',
    isRequired: false,
    isSearchable: false,
};
exports.height = {
    name: 'height',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Height'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.newHeight = {
    name: 'height',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Height'),
    attributeConstraint: 'None',
    isRequired: false,
    isSearchable: false,
};
exports.weight = {
    name: 'weight',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Weight'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.newWeight = {
    name: 'weight',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Weight'),
    attributeConstraint: 'None',
    isRequired: false,
    isSearchable: false,
};
exports.legWidth = {
    name: 'legWidth',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Leg Width'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: true,
};
exports.heelHeight = {
    name: 'heelHeight',
    type: {
        name: 'number',
    },
    label: (0, i18n_1.localizedString)('Heel Height'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.newHeelHeight = {
    name: 'heelHeight',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Heel Height'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.bootLegCircumference = {
    name: 'bootLegCircumference',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Boot Leg Circumference'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.bootLegHeight = {
    name: 'bootLegHeight',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Boot Leg Height'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.upperMaterial = {
    name: 'upperMaterial',
    type: {
        name: 'ltext',
    },
    label: {
        ...(0, i18n_1.localizedString)('Upper Material'),
        ...(0, i18n_1.localizedString)('Upper Material', i18n_1.Locale.EN_GB),
        ...(0, i18n_1.localizedString)('Upper Material', i18n_1.Locale.EN_GB_OUTLET),
        ...(0, i18n_1.localizedString)('Upper Material', i18n_1.Locale.EN_US),
        ...(0, i18n_1.localizedString)('Upper Material', i18n_1.Locale.EN_IE),
        ...(0, i18n_1.localizedString)('Upper Material', i18n_1.Locale.EN_CA),
        ...(0, i18n_1.localizedString)('Tige', i18n_1.Locale.FR_CA),
        ...(0, i18n_1.localizedString)('Obermaterial', i18n_1.Locale.DE_AT),
        ...(0, i18n_1.localizedString)('Obermaterial', i18n_1.Locale.DE_DE),
        ...(0, i18n_1.localizedString)('Obermaterial', i18n_1.Locale.DE_CH),
        ...(0, i18n_1.localizedString)('Matière supérieure', i18n_1.Locale.FR_BE),
        ...(0, i18n_1.localizedString)('Matière supérieure', i18n_1.Locale.FR_CH),
        ...(0, i18n_1.localizedString)('Matière supérieure', i18n_1.Locale.FR_FR),
        ...(0, i18n_1.localizedString)('Matière supérieure', i18n_1.Locale.FR_LU),
        ...(0, i18n_1.localizedString)('Materiale di qualità superiore', i18n_1.Locale.IT_CH),
        ...(0, i18n_1.localizedString)('Materiale di qualità superiore', i18n_1.Locale.IT_IT),
        ...(0, i18n_1.localizedString)('Materiale di qualità superiore', i18n_1.Locale.IT_SM),
        ...(0, i18n_1.localizedString)('Bovenmateriaal', i18n_1.Locale.NL_BE),
        ...(0, i18n_1.localizedString)('Bovenmateriaal', i18n_1.Locale.NL_NL),
        ...(0, i18n_1.localizedString)('Material superior', i18n_1.Locale.ES_ES),
    },
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.liningMaterial = {
    name: 'liningMaterial',
    type: {
        name: 'ltext',
    },
    label: {
        ...(0, i18n_1.localizedString)('Lining Material'),
        ...(0, i18n_1.localizedString)('Lining Material', i18n_1.Locale.EN_GB),
        ...(0, i18n_1.localizedString)('Lining Material', i18n_1.Locale.EN_GB_OUTLET),
        ...(0, i18n_1.localizedString)('Lining Material', i18n_1.Locale.EN_US),
        ...(0, i18n_1.localizedString)('Lining Material', i18n_1.Locale.EN_IE),
        ...(0, i18n_1.localizedString)('Lining Material', i18n_1.Locale.EN_CA),
        ...(0, i18n_1.localizedString)('Doublure', i18n_1.Locale.FR_CA),
        ...(0, i18n_1.localizedString)('Matériau de doublure', i18n_1.Locale.FR_BE),
        ...(0, i18n_1.localizedString)('Matériau de doublure', i18n_1.Locale.FR_CH),
        ...(0, i18n_1.localizedString)('Matériau de doublure', i18n_1.Locale.FR_FR),
        ...(0, i18n_1.localizedString)('Matériau de doublure', i18n_1.Locale.FR_LU),
        ...(0, i18n_1.localizedString)('Futtermaterial', i18n_1.Locale.DE_AT),
        ...(0, i18n_1.localizedString)('Futtermaterial', i18n_1.Locale.DE_DE),
        ...(0, i18n_1.localizedString)('Futtermaterial', i18n_1.Locale.DE_CH),
        ...(0, i18n_1.localizedString)('Voeringmateriaal', i18n_1.Locale.NL_BE),
        ...(0, i18n_1.localizedString)('Voeringmateriaal', i18n_1.Locale.NL_NL),
        ...(0, i18n_1.localizedString)('Materiale di rivestimento', i18n_1.Locale.IT_CH),
        ...(0, i18n_1.localizedString)('Materiale di rivestimento', i18n_1.Locale.IT_IT),
        ...(0, i18n_1.localizedString)('Materiale di rivestimento', i18n_1.Locale.IT_SM),
        ...(0, i18n_1.localizedString)('Material del forro', i18n_1.Locale.ES_ES),
    },
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.soleMaterial = {
    name: 'soleMaterial',
    type: {
        name: 'ltext',
    },
    label: {
        ...(0, i18n_1.localizedString)('Sole Material'),
        ...(0, i18n_1.localizedString)('Sole Material', i18n_1.Locale.EN_GB),
        ...(0, i18n_1.localizedString)('Sole Material', i18n_1.Locale.EN_GB_OUTLET),
        ...(0, i18n_1.localizedString)('Sole Material', i18n_1.Locale.EN_US),
        ...(0, i18n_1.localizedString)('Sole Material', i18n_1.Locale.EN_IE),
        ...(0, i18n_1.localizedString)('Sole Material', i18n_1.Locale.EN_CA),
        ...(0, i18n_1.localizedString)('Semelle', i18n_1.Locale.FR_CA),
        ...(0, i18n_1.localizedString)('Sohlenmaterial', i18n_1.Locale.DE_AT),
        ...(0, i18n_1.localizedString)('Sohlenmaterial', i18n_1.Locale.DE_DE),
        ...(0, i18n_1.localizedString)('Sohlenmaterial', i18n_1.Locale.DE_CH),
        ...(0, i18n_1.localizedString)('Material de la suela', i18n_1.Locale.ES_ES),
        ...(0, i18n_1.localizedString)('Matériau de semelle', i18n_1.Locale.FR_BE),
        ...(0, i18n_1.localizedString)('Matériau de semelle', i18n_1.Locale.FR_CH),
        ...(0, i18n_1.localizedString)('Matériau de semelle', i18n_1.Locale.FR_FR),
        ...(0, i18n_1.localizedString)('Matériau de semelle', i18n_1.Locale.FR_LU),
        ...(0, i18n_1.localizedString)('Materiale della suola', i18n_1.Locale.IT_CH),
        ...(0, i18n_1.localizedString)('Materiale della suola', i18n_1.Locale.IT_IT),
        ...(0, i18n_1.localizedString)('Materiale della suola', i18n_1.Locale.IT_SM),
        ...(0, i18n_1.localizedString)('Zoolmateriaal', i18n_1.Locale.NL_BE),
        ...(0, i18n_1.localizedString)('Zoolmateriaal', i18n_1.Locale.NL_NL),
    },
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.fastening = {
    name: 'fastening',
    type: {
        name: 'ltext',
    },
    label: {
        ...(0, i18n_1.localizedString)('Fastening Type'),
        ...(0, i18n_1.localizedString)('Fastening Type', i18n_1.Locale.EN_GB),
        ...(0, i18n_1.localizedString)('Fastening Type', i18n_1.Locale.EN_GB_OUTLET),
        ...(0, i18n_1.localizedString)('Fastening Type', i18n_1.Locale.EN_US),
        ...(0, i18n_1.localizedString)('Fastening Type', i18n_1.Locale.EN_IE),
        ...(0, i18n_1.localizedString)('Fastening Type', i18n_1.Locale.EN_CA),
        ...(0, i18n_1.localizedString)('Fermeture', i18n_1.Locale.FR_CA),
        ...(0, i18n_1.localizedString)('Type de fermeture', i18n_1.Locale.FR_BE),
        ...(0, i18n_1.localizedString)('Type de fermeture', i18n_1.Locale.FR_CH),
        ...(0, i18n_1.localizedString)('Type de fermeture', i18n_1.Locale.FR_FR),
        ...(0, i18n_1.localizedString)('Type de fermeture', i18n_1.Locale.FR_LU),
        ...(0, i18n_1.localizedString)('Verschlusstyp', i18n_1.Locale.DE_AT),
        ...(0, i18n_1.localizedString)('Verschlusstyp', i18n_1.Locale.DE_DE),
        ...(0, i18n_1.localizedString)('Verschlusstyp', i18n_1.Locale.DE_CH),
        ...(0, i18n_1.localizedString)('Tipo di chiusura', i18n_1.Locale.IT_CH),
        ...(0, i18n_1.localizedString)('Tipo di chiusura', i18n_1.Locale.IT_IT),
        ...(0, i18n_1.localizedString)('Tipo di chiusura', i18n_1.Locale.IT_SM),
        ...(0, i18n_1.localizedString)('Tipo de cierre', i18n_1.Locale.ES_ES),
        ...(0, i18n_1.localizedString)('Sluitingstype', i18n_1.Locale.NL_BE),
        ...(0, i18n_1.localizedString)('Sluitingstype', i18n_1.Locale.NL_NL),
    },
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.trims = {
    name: 'trims',
    type: {
        name: 'set',
        elementType: {
            name: 'ltext',
        },
    },
    label: {
        ...(0, i18n_1.localizedString)('Trims'),
        ...(0, i18n_1.localizedString)('Trims', i18n_1.Locale.EN_GB),
        ...(0, i18n_1.localizedString)('Trims', i18n_1.Locale.EN_GB_OUTLET),
        ...(0, i18n_1.localizedString)('Trims', i18n_1.Locale.EN_US),
        ...(0, i18n_1.localizedString)('Trims', i18n_1.Locale.EN_IE),
        ...(0, i18n_1.localizedString)('Trims', i18n_1.Locale.EN_CA),
        ...(0, i18n_1.localizedString)('Ornement', i18n_1.Locale.FR_CA),
        ...(0, i18n_1.localizedString)('Verzierungen', i18n_1.Locale.DE_AT),
        ...(0, i18n_1.localizedString)('Verzierungen', i18n_1.Locale.DE_DE),
        ...(0, i18n_1.localizedString)('Verzierungen', i18n_1.Locale.DE_CH),
        ...(0, i18n_1.localizedString)('Adornos', i18n_1.Locale.ES_ES),
        ...(0, i18n_1.localizedString)('Garnitures', i18n_1.Locale.FR_BE),
        ...(0, i18n_1.localizedString)('Garnitures', i18n_1.Locale.FR_CH),
        ...(0, i18n_1.localizedString)('Garnitures', i18n_1.Locale.FR_FR),
        ...(0, i18n_1.localizedString)('Garnitures', i18n_1.Locale.FR_LU),
        ...(0, i18n_1.localizedString)('Rifiniture', i18n_1.Locale.IT_CH),
        ...(0, i18n_1.localizedString)('Rifiniture', i18n_1.Locale.IT_IT),
        ...(0, i18n_1.localizedString)('Rifiniture', i18n_1.Locale.IT_SM),
        ...(0, i18n_1.localizedString)('Decoraties', i18n_1.Locale.NL_BE),
        ...(0, i18n_1.localizedString)('Decoraties', i18n_1.Locale.NL_NL),
    },
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.sockMaterial = {
    name: 'sockMaterial',
    type: {
        name: 'ltext',
    },
    label: {
        ...(0, i18n_1.localizedString)('Sock Material'),
        ...(0, i18n_1.localizedString)('Sock Material', i18n_1.Locale.EN_GB),
        ...(0, i18n_1.localizedString)('Sock Material', i18n_1.Locale.EN_GB_OUTLET),
        ...(0, i18n_1.localizedString)('Sock Material', i18n_1.Locale.EN_US),
        ...(0, i18n_1.localizedString)('Sock Material', i18n_1.Locale.EN_IE),
        ...(0, i18n_1.localizedString)('Sock Material', i18n_1.Locale.EN_CA),
        ...(0, i18n_1.localizedString)('Sock Material', i18n_1.Locale.FR_CA),
        ...(0, i18n_1.localizedString)('Sockenmaterial', i18n_1.Locale.DE_AT),
        ...(0, i18n_1.localizedString)('Sockenmaterial', i18n_1.Locale.DE_DE),
        ...(0, i18n_1.localizedString)('Sockenmaterial', i18n_1.Locale.DE_CH),
        ...(0, i18n_1.localizedString)('Material del calcetín', i18n_1.Locale.ES_ES),
        ...(0, i18n_1.localizedString)('Matériau de la chaussette', i18n_1.Locale.FR_BE),
        ...(0, i18n_1.localizedString)('Matériau de la chaussette', i18n_1.Locale.FR_CH),
        ...(0, i18n_1.localizedString)('Matériau de la chaussette', i18n_1.Locale.FR_FR),
        ...(0, i18n_1.localizedString)('Matériau de la chaussette', i18n_1.Locale.FR_LU),
        ...(0, i18n_1.localizedString)('Materiale del calzino', i18n_1.Locale.IT_CH),
        ...(0, i18n_1.localizedString)('Materiale del calzino', i18n_1.Locale.IT_IT),
        ...(0, i18n_1.localizedString)('Materiale del calzino', i18n_1.Locale.IT_SM),
        ...(0, i18n_1.localizedString)('Sokmateriaal', i18n_1.Locale.NL_BE),
        ...(0, i18n_1.localizedString)('Sokmateriaal', i18n_1.Locale.NL_NL),
    },
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.productCollection = {
    name: 'productCollection',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Product Collection'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.productPurpose = {
    name: 'productPurpose',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Product Purpose'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.videoUrl = {
    name: 'videoUrl',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Video Url'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.newVideoUrl = {
    name: 'videoUrl',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Video Url'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.spinUrl = {
    name: 'spinUrl',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Spin Url'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.constructionMaking = {
    name: 'constructionMaking',
    type: {
        name: 'ltext',
    },
    label: {
        ...(0, i18n_1.localizedString)('Construction Making'),
        ...(0, i18n_1.localizedString)('Construction Making', i18n_1.Locale.EN_GB),
        ...(0, i18n_1.localizedString)('Construction Making', i18n_1.Locale.EN_GB_OUTLET),
        ...(0, i18n_1.localizedString)('Construction Making', i18n_1.Locale.EN_US),
        ...(0, i18n_1.localizedString)('Construction Making', i18n_1.Locale.EN_IE),
        ...(0, i18n_1.localizedString)('Construction Making', i18n_1.Locale.EN_CA),
        ...(0, i18n_1.localizedString)('Construction Making', i18n_1.Locale.FR_CA),
        ...(0, i18n_1.localizedString)('Konstruktion', i18n_1.Locale.DE_AT),
        ...(0, i18n_1.localizedString)('Konstruktion', i18n_1.Locale.DE_DE),
        ...(0, i18n_1.localizedString)('Konstruktion', i18n_1.Locale.DE_CH),
        ...(0, i18n_1.localizedString)('Construcción', i18n_1.Locale.ES_ES),
        ...(0, i18n_1.localizedString)('Fabrication', i18n_1.Locale.FR_BE),
        ...(0, i18n_1.localizedString)('Fabrication', i18n_1.Locale.FR_CH),
        ...(0, i18n_1.localizedString)('Fabrication', i18n_1.Locale.FR_FR),
        ...(0, i18n_1.localizedString)('Fabrication', i18n_1.Locale.FR_LU),
        ...(0, i18n_1.localizedString)('Costruzione', i18n_1.Locale.IT_CH),
        ...(0, i18n_1.localizedString)('Costruzione', i18n_1.Locale.IT_IT),
        ...(0, i18n_1.localizedString)('Costruzione', i18n_1.Locale.IT_SM),
        ...(0, i18n_1.localizedString)('Constructie', i18n_1.Locale.NL_BE),
        ...(0, i18n_1.localizedString)('Constructie', i18n_1.Locale.NL_NL),
    },
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.removableInsole = {
    name: 'removableInsole',
    type: {
        name: 'boolean',
    },
    label: {
        ...(0, i18n_1.localizedString)('Removable Insole'),
        ...(0, i18n_1.localizedString)('Removable Insole', i18n_1.Locale.EN_GB),
        ...(0, i18n_1.localizedString)('Removable Insole', i18n_1.Locale.EN_GB_OUTLET),
        ...(0, i18n_1.localizedString)('Removable Insole', i18n_1.Locale.EN_US),
        ...(0, i18n_1.localizedString)('Removable Insole', i18n_1.Locale.EN_IE),
        ...(0, i18n_1.localizedString)('Removable Insole', i18n_1.Locale.EN_CA),
        ...(0, i18n_1.localizedString)('Semelle intérieure amovible', i18n_1.Locale.FR_CA),
        ...(0, i18n_1.localizedString)('Herausnehmbare Einlegesohle', i18n_1.Locale.DE_AT),
        ...(0, i18n_1.localizedString)('Herausnehmbare Einlegesohle', i18n_1.Locale.DE_DE),
        ...(0, i18n_1.localizedString)('Herausnehmbare Einlegesohle', i18n_1.Locale.DE_CH),
        ...(0, i18n_1.localizedString)('Plantilla extraíble', i18n_1.Locale.ES_ES),
        ...(0, i18n_1.localizedString)('Semelle intérieure amovible', i18n_1.Locale.FR_BE),
        ...(0, i18n_1.localizedString)('Semelle intérieure amovible', i18n_1.Locale.FR_CH),
        ...(0, i18n_1.localizedString)('Semelle intérieure amovible', i18n_1.Locale.FR_FR),
        ...(0, i18n_1.localizedString)('Semelle intérieure amovible', i18n_1.Locale.FR_LU),
        ...(0, i18n_1.localizedString)('Soletta rimovibile', i18n_1.Locale.IT_CH),
        ...(0, i18n_1.localizedString)('Soletta rimovibile', i18n_1.Locale.IT_IT),
        ...(0, i18n_1.localizedString)('Soletta rimovibile', i18n_1.Locale.IT_SM),
        ...(0, i18n_1.localizedString)('Uitneembare binnenzool', i18n_1.Locale.NL_BE),
        ...(0, i18n_1.localizedString)('Uitneembare binnenzool', i18n_1.Locale.NL_NL),
    },
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.upperMaterialGroup = {
    name: 'upperMaterialGroup',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Upper Material Group'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.commodityCode = {
    name: 'commodityCode',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Commodity Code'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.newCommodityCode = {
    name: 'commodityCode',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Commodity Code'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.smallerSizes = {
    name: 'smallerSizes',
    type: {
        name: 'reference',
        referenceTypeId: 'product',
    },
    label: (0, i18n_1.localizedString)('Smaller Sizes'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.largerSizes = {
    name: 'largerSizes',
    type: {
        name: 'reference',
        referenceTypeId: 'product',
    },
    label: (0, i18n_1.localizedString)('Larger Sizes'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.midSoleMaterial = {
    name: 'midSoleMaterial',
    type: {
        name: 'ltext',
    },
    label: {
        ...(0, i18n_1.localizedString)('Midsole Material'),
        ...(0, i18n_1.localizedString)('Midsole Material', i18n_1.Locale.EN_GB),
        ...(0, i18n_1.localizedString)('Midsole Material', i18n_1.Locale.EN_GB_OUTLET),
        ...(0, i18n_1.localizedString)('Midsole Material', i18n_1.Locale.EN_US),
        ...(0, i18n_1.localizedString)('Midsole Material', i18n_1.Locale.EN_IE),
        ...(0, i18n_1.localizedString)('Midsole Material', i18n_1.Locale.EN_CA),
        ...(0, i18n_1.localizedString)('Semelle Intermédiaire', i18n_1.Locale.FR_CA),
        ...(0, i18n_1.localizedString)('Zwischensohlenmaterial', i18n_1.Locale.DE_AT),
        ...(0, i18n_1.localizedString)('Zwischensohlenmaterial', i18n_1.Locale.DE_DE),
        ...(0, i18n_1.localizedString)('Zwischensohlenmaterial', i18n_1.Locale.DE_CH),
        ...(0, i18n_1.localizedString)('Material de la entresuela', i18n_1.Locale.ES_ES),
        ...(0, i18n_1.localizedString)('Matériau intermédiaire', i18n_1.Locale.FR_BE),
        ...(0, i18n_1.localizedString)('Matériau intermédiaire', i18n_1.Locale.FR_CH),
        ...(0, i18n_1.localizedString)('Matériau intermédiaire', i18n_1.Locale.FR_FR),
        ...(0, i18n_1.localizedString)('Matériau intermédiaire', i18n_1.Locale.FR_LU),
        ...(0, i18n_1.localizedString)('Materiale intermedio', i18n_1.Locale.IT_CH),
        ...(0, i18n_1.localizedString)('Materiale intermedio', i18n_1.Locale.IT_IT),
        ...(0, i18n_1.localizedString)('Materiale intermedio', i18n_1.Locale.IT_SM),
        ...(0, i18n_1.localizedString)('Tussenzoolmateriaal', i18n_1.Locale.NL_BE),
        ...(0, i18n_1.localizedString)('Tussenzoolmateriaal', i18n_1.Locale.NL_NL),
    },
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.removableFootbed = {
    name: 'removableFootbed',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Removable footbed'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.technologies = {
    name: 'technologies',
    type: {
        name: 'set',
        elementType: {
            name: 'ltext',
        },
    },
    label: (0, i18n_1.localizedString)('Technologies'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.featureDescription = {
    name: 'featureDescription',
    type: {
        name: 'set',
        elementType: {
            name: 'ltext',
        },
    },
    label: (0, i18n_1.localizedString)('Feature description'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.endUse = {
    name: 'endUse',
    type: {
        name: 'set',
        elementType: {
            name: 'ltext',
        },
    },
    label: (0, i18n_1.localizedString)('End use'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.vertexTaxGroup = {
    name: 'vertexTaxGroup',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Vertex Tax Group ID'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.heelHeightUnit = {
    name: 'heelHeightUnit',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Heel Height Unit'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.newHeelHeightUnit = {
    name: 'heelHeightUnit',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Heel Height Unit'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.bootShaftHeightUnit = {
    name: 'bootShaftHeightUnit',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Boot Shaft Height Unit'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.newBootShaftHeightUnit = {
    name: 'bootShaftHeightUnit',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Boot Shaft Height Unit'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.bootShaftCircumferenceUnit = {
    name: 'bootShaftCircumferenceUnit',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Boot Shaft Circumference Unit'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.newBootShaftCircumferenceUnit = {
    name: 'bootShaftCircumferenceUnit',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Boot Shaft Circumference Unit'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.widthUnit = {
    name: 'widthUnit',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Width Unit'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.newWidthUnit = {
    name: 'widthUnit',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Width Unit'),
    attributeConstraint: 'None',
    isRequired: false,
    isSearchable: false,
};
exports.heightUnit = {
    name: 'heightUnit',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Height Unit'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.newHeightUnit = {
    name: 'heightUnit',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Height Unit'),
    attributeConstraint: 'None',
    isRequired: false,
    isSearchable: false,
};
exports.lengthUnit = {
    name: 'lengthUnit',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Length Unit'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.newLengthUnit = {
    name: 'lengthUnit',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Length Unit'),
    attributeConstraint: 'None',
    isRequired: false,
    isSearchable: false,
};
exports.weightUnit = {
    name: 'weightUnit',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Weight Unit'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.newWeightUnit = {
    name: 'weightUnit',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Weight Unit'),
    attributeConstraint: 'None',
    isRequired: false,
    isSearchable: false,
};
exports.bootShaftHeight = {
    name: 'bootShaftHeight',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Boot Shaft Height'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.newBootShaftHeight = {
    name: 'bootShaftHeight',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Boot Shaft Height'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.bootShaftCircumference = {
    name: 'bootShaftCircumference',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Boot Shaft Circumference'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.newBootShaftCircumference = {
    name: 'bootShaftCircumference',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Boot Shaft Circumference'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.productAvailabilityDate = {
    name: 'productAvailabilityDate',
    type: {
        name: 'ltext',
    },
    label: {
        ...(0, i18n_1.localizedString)('Availability Date'),
        ...(0, i18n_1.localizedString)('Availability Date', i18n_1.Locale.EN_GB),
        ...(0, i18n_1.localizedString)('Availability Date', i18n_1.Locale.EN_GB_OUTLET),
        ...(0, i18n_1.localizedString)('Availability Date', i18n_1.Locale.EN_US),
        ...(0, i18n_1.localizedString)('Availability Date', i18n_1.Locale.EN_IE),
        ...(0, i18n_1.localizedString)('Availability Date', i18n_1.Locale.EN_CA),
        ...(0, i18n_1.localizedString)('Date de disponibilité', i18n_1.Locale.FR_CA),
        ...(0, i18n_1.localizedString)('Verfügbarkeitsdatum', i18n_1.Locale.DE_AT),
        ...(0, i18n_1.localizedString)('Verfügbarkeitsdatum', i18n_1.Locale.DE_DE),
        ...(0, i18n_1.localizedString)('Verfügbarkeitsdatum', i18n_1.Locale.DE_CH),
        ...(0, i18n_1.localizedString)('Fecha de disponibilidad', i18n_1.Locale.ES_ES),
        ...(0, i18n_1.localizedString)('Date de disponibilité', i18n_1.Locale.FR_BE),
        ...(0, i18n_1.localizedString)('Date de disponibilité', i18n_1.Locale.FR_CH),
        ...(0, i18n_1.localizedString)('Date de disponibilité', i18n_1.Locale.FR_FR),
        ...(0, i18n_1.localizedString)('Date de disponibilité', i18n_1.Locale.FR_LU),
        ...(0, i18n_1.localizedString)('Data di disponibilità', i18n_1.Locale.IT_CH),
        ...(0, i18n_1.localizedString)('Data di disponibilità', i18n_1.Locale.IT_IT),
        ...(0, i18n_1.localizedString)('Data di disponibilità', i18n_1.Locale.IT_SM),
        ...(0, i18n_1.localizedString)('Beschikbaarheidsdatum', i18n_1.Locale.NL_BE),
        ...(0, i18n_1.localizedString)('Beschikbaarheidsdatum', i18n_1.Locale.NL_NL),
    },
    attributeConstraint: 'None',
    isRequired: false,
    isSearchable: false,
};
exports.productEndDate = {
    name: 'productEndDate',
    type: {
        name: 'ltext',
    },
    label: {
        ...(0, i18n_1.localizedString)('End Date'),
        ...(0, i18n_1.localizedString)('End Date', i18n_1.Locale.EN_GB),
        ...(0, i18n_1.localizedString)('End Date', i18n_1.Locale.EN_GB_OUTLET),
        ...(0, i18n_1.localizedString)('End Date', i18n_1.Locale.EN_US),
        ...(0, i18n_1.localizedString)('End Date', i18n_1.Locale.EN_IE),
        ...(0, i18n_1.localizedString)('End Date', i18n_1.Locale.EN_CA),
        ...(0, i18n_1.localizedString)('Date de fin', i18n_1.Locale.FR_CA),
        ...(0, i18n_1.localizedString)('Enddatum', i18n_1.Locale.DE_AT),
        ...(0, i18n_1.localizedString)('Enddatum', i18n_1.Locale.DE_DE),
        ...(0, i18n_1.localizedString)('Enddatum', i18n_1.Locale.DE_CH),
        ...(0, i18n_1.localizedString)('Fecha de finalización', i18n_1.Locale.ES_ES),
        ...(0, i18n_1.localizedString)('Date de fin', i18n_1.Locale.FR_BE),
        ...(0, i18n_1.localizedString)('Date de fin', i18n_1.Locale.FR_CH),
        ...(0, i18n_1.localizedString)('Date de fin', i18n_1.Locale.FR_FR),
        ...(0, i18n_1.localizedString)('Date de fin', i18n_1.Locale.FR_LU),
        ...(0, i18n_1.localizedString)('Data di fine', i18n_1.Locale.IT_CH),
        ...(0, i18n_1.localizedString)('Data di fine', i18n_1.Locale.IT_IT),
        ...(0, i18n_1.localizedString)('Data di fine', i18n_1.Locale.IT_SM),
        ...(0, i18n_1.localizedString)('Einddatum', i18n_1.Locale.NL_BE),
        ...(0, i18n_1.localizedString)('Einddatum', i18n_1.Locale.NL_NL),
    },
    attributeConstraint: 'None',
    isRequired: false,
    isSearchable: false,
};
exports.merchandiseCategory = {
    name: 'merchandiseCategory',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Merchandise Category'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.rangeGroupDescription = {
    name: 'rangeGroupDescription',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Range group description'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.productSlug = {
    name: 'productSlug',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Product Slug'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
const productBadges = (badgeTypeId) => ({
    name: 'productBadges',
    type: {
        name: 'set',
        elementType: {
            name: 'nested',
            typeReference: {
                typeId: 'product-type',
                id: badgeTypeId,
            },
        },
    },
    label: (0, i18n_1.localizedString)('Badges'),
    attributeConstraint: 'SameForAll',
    isSearchable: true,
    isRequired: false,
});
exports.productBadges = productBadges;
exports.subTechnologies = {
    name: 'subTechnologies',
    type: {
        name: 'set',
        elementType: {
            name: 'ltext',
        },
    },
    label: (0, i18n_1.localizedString)('Subtechnologies'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.crossSellsPDPMiniMeMensAndBoys = {
    name: 'crossSellsPDPMiniMeMensAndBoys',
    type: {
        name: 'set',
        elementType: {
            name: 'reference',
            referenceTypeId: 'product',
        },
    },
    label: (0, i18n_1.localizedString)('Cross-Sells - Mini Me, Mens and Boys'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.crossSellsPDPMiniMeWomensAndGirls = {
    name: 'crossSellsPDPMiniMeWomensAndGirls',
    type: {
        name: 'set',
        elementType: {
            name: 'reference',
            referenceTypeId: 'product',
        },
    },
    label: (0, i18n_1.localizedString)('Cross-Sells - Mini Me, Womens and Girls'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.crossSellsPDPWomensShoesAndHandbags = {
    name: 'crossSellsPDPWomensShoesAndHandbags',
    type: {
        name: 'set',
        elementType: {
            name: 'reference',
            referenceTypeId: 'product',
        },
    },
    label: (0, i18n_1.localizedString)('Cross-Sells - Womens Shoes and Handbags'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.upsellsCheckoutJuniorGauges = {
    name: 'upsellsCheckoutJuniorGauges',
    type: {
        name: 'set',
        elementType: {
            name: 'reference',
            referenceTypeId: 'product',
        },
    },
    label: (0, i18n_1.localizedString)('Upsells Checkout - Junior Gauges'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.upsellsCheckoutToddlerGauges = {
    name: 'upsellsCheckoutToddlerGauges',
    type: {
        name: 'set',
        elementType: {
            name: 'reference',
            referenceTypeId: 'product',
        },
    },
    label: (0, i18n_1.localizedString)('Upsells Checkout - Toddler Gauges'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.upsellsCheckoutShoesAndShoeCare = {
    name: 'upsellsCheckoutShoesAndShoeCare',
    type: {
        name: 'set',
        elementType: {
            name: 'reference',
            referenceTypeId: 'product',
        },
    },
    label: (0, i18n_1.localizedString)('Upsells Checkout - Shoe and ShoeCare'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.finalSale = {
    name: 'finalSale',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Customer-facing attribute: On Final Sale'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.storefrontText = {
    name: 'storefrontText',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Customer-facing attribute: Storefront Text'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.emailText = {
    name: 'emailText',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Customer-facing attribute: Email Text'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.foregroundColor = {
    name: 'foregroundColor',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Customer-facing attribute: Foreground Color'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.backgroundColor = {
    name: 'backgroundColor',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Customer-facing attribute: Background Color'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.shippingAndReturnsText = {
    name: 'shippingAndReturnsText',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Shipping and returns: text'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.shippingAndReturnsImage = {
    name: 'shippingAndReturnsImage',
    type: {
        name: 'text',
    },
    label: (0, i18n_1.localizedString)('Shipping and returns: image url'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.lastOfferedAtDate = {
    name: 'lastOfferedAtDate',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Last Offered At Date'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.fromDate = {
    name: 'fromDate',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('From Date'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.toDate = {
    name: 'toDate',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('To Date'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.productIndex = {
    name: 'index',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Indexed by search engines'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.productFollow = {
    name: 'follow',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Followed by search engines'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.isFullPriceProduct = {
    name: 'isFullPriceProduct',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Full Price Product'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.isClearance = {
    name: 'isClearance',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Clearance'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.productLaunchDate = {
    name: 'launchDate',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Launch Date'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.productTitle = {
    name: 'title',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Title'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
exports.productShortDescription = {
    name: 'shortDescription',
    type: {
        name: 'ltext',
    },
    label: (0, i18n_1.localizedString)('Short Description'),
    attributeConstraint: 'SameForAll',
    isRequired: false,
    isSearchable: false,
};
//# sourceMappingURL=core-attributes.js.map